<template>
  <div>
    <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="$t('merchandise', 'goodsList')" name="first">
        <productList v-if="activeName == 'first'"  :jurisdiction="jurisdiction"/>
      </el-tab-pane>

      <el-tab-pane :label="$t('merchandise', 'goodsCategory')" name="second">
        <classifyList v-if="activeName == 'second'" :jurisdiction="jurisdiction"/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import productList from "./components/productList.vue";
import classifyList from "./components/classifyList.vue";
import { mapState } from 'vuex';
import i18nMixin from '@/mixins/i18nMixin';

export default {
  name: "management",
  mixins: [i18nMixin],
  components: {
    productList,
    classifyList,
  },

  data() {
    return {
      activeName: "first",
      jurisdiction:false,
    };
  },
  computed: {
    ...mapState(['routerArr']),
  },
  created(){
    if(this.$route.query.name){
      this.activeName = this.$route.query.name
    }
  },
  watch:{
    routerArr(val){
      this.jurisdiction = val.includes("040")
      console.log(this.jurisdiction,'this.jurisdiction')
    },
  },
  methods: {
    handleClick(tab) {
      const { name } = tab;
      this.activeName = name;
    },
  },
};
</script>

<style lang="scss" scoped></style>
